import { useEffect, useState } from "react";
import AnimatedLetters from "../AnimatedLetters/AnimatedLetters";
import { Outlet, Link } from "react-router-dom";
import { education } from "../../data/profileData";
import "./About.scss";

function About() {
  const [letterClass, setLetterClass] = useState("text-animate");

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3300);
  }, []);

  return (
    <div className="container about-page">
      <div className="page">
        <span className="tags top-html">&lt;/html&gt;</span>
        <span className="tags top-tags">&lt;body&gt;</span>

        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={[
                "M",
                "e",
                ",",
                " ",
                "M",
                "y",
                "s",
                "e",
                "l",
                "f",
                " ",
                "&",
                " ",
                "I",
              ]}
              idx={15}
            />
          </h1>
          <p>
            I&apos;m a final year ENTC engineer at {education.college},
            focused on AI systems and backend engineering. I work across
            distributed systems, event-driven architectures, and AI
            infrastructure &mdash; building GraphRAG and retrieval pipelines
            over knowledge graphs and vector stores, streaming data systems,
            and provenance-aware context layers, with an emphasis on clean
            architecture and production readiness.
            <br />
            <br />
            &bull; AI Systems &amp; Backend Engineering Intern at Semantica,
            working on semantic retrieval and knowledge graph systems
            <br />
            &bull; {education.degree} at {education.college}
            <br />
            &bull; 150+ problems solved on LeetCode and HackerRank
            <br />
            <br />
            My work sits at the intersection of backend engineering and AI
            systems &mdash; graph-based retrieval, knowledge graph construction,
            and provenance-aware context pipelines, data moving reliably through
            Spark and Delta Lake, and systems designed to be observable and
            testable.
            <br />
            <br />
            I&apos;m open to relevant engineering opportunities &mdash; technically
            strong projects and roles where this kind of work matters.
            <Link to="/contact" className="reach">
              Reach out to me!
            </Link>
          </p>
          <div className="myCv">
            <div className="rtext">My Resume</div>
            <div className="okay">
              <a
                href="https://drive.google.com/file/d/10H4GixbftNc3bzWHvh8KJbqe12w1rlnt/view?usp=drive_link"
                target="__blank"
              >
                CLICK HERE TO VIEW PDF
              </a>
            </div>
          </div>
        </div>

        <Outlet />
        <span className="tags bottom-tags">
          &lt;/body&gt;
          <br />
          <span className="bottom-tag-html">&lt;/html&gt;</span>
        </span>
      </div>
    </div>
  );
}

export default About;
